import AccountActions from 'components/AccountActions';
import React from 'react';

import OPCImg from 'assets/img/logo-sentinel-inline.png';

import { Link } from 'react-router-dom';
import styles from './styles.module.scss';

const Header: React.FC = () => (
  <header className={styles.wrapper}>
    <div className="container d-flex justify-content-between p-2 align-items-center">
      <div className={styles.logo}>
        <Link to="/">
          <img src={OPCImg} alt="OPC Sentinel" />
        </Link>
      </div>

      <AccountActions />
    </div>
  </header>
);

export default Header;
